import { render, staticRenderFns } from "./viewContacts.vue?vue&type=template&id=c5c44a24&scoped=true"
import script from "./viewContacts.vue?vue&type=script&lang=js"
export * from "./viewContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c44a24",
  null
  
)

export default component.exports